import { EDITABLE_TEXT_PROPERTIES } from '@/enums';
import { TextStyleType } from '@/types';

export const DEFAULT_FONT_SIZES = [
  2, 3, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 32, 36, 40, 48, 56, 64, 72, 80, 88, 96,
  104, 112, 120, 128, 136, 144, 152, 160, 168, 176, 184, 192
];

export const mapFabricObjectToTextStyle = (obj: fabric.Textbox) => {
  const style: Record<string, unknown> = {};
  Object.keys(EDITABLE_TEXT_PROPERTIES).forEach((key) => {
    style[key] = obj[key as keyof fabric.Textbox];
  });
  return style as TextStyleType;
};

// This function returns an object where all properties are set to true.
// Later, if a property changes, its value will be set to false.
const getUniformBaseValues = () => {
  const style: Record<string, boolean> = {};
  Object.values(EDITABLE_TEXT_PROPERTIES).forEach((key) => {
    style[key] = true;
  });
  return style as Record<EDITABLE_TEXT_PROPERTIES, boolean>;
};

// This function checks which properties have the same value across all selected objects.
// Properties that are identical in all objects will be set to true, while the others will be set to false.
export const getUniformStyleProps = (
  selectedObjects: Record<string, fabric.Object>,
  selectedIds: string[]
): Record<EDITABLE_TEXT_PROPERTIES, boolean> => {
  const uniformBaseValues = getUniformBaseValues();
  let comparisonBaseValues: TextStyleType;

  selectedIds.forEach((id, idx) => {
    const obj = selectedObjects[id] as fabric.Textbox;
    if (idx === 0) {
      comparisonBaseValues = mapFabricObjectToTextStyle(obj);
    } else {
      Object.keys(uniformBaseValues).forEach((key) => {
        if (
          obj[key as keyof fabric.Textbox] !== comparisonBaseValues[key as EDITABLE_TEXT_PROPERTIES]
        ) {
          uniformBaseValues[key as EDITABLE_TEXT_PROPERTIES] = false;
        }
      });
    }
  });

  return uniformBaseValues;
};

// This function returns an object with the values that are common across all selected objects,
// while the properties that differ are set to null.
export const getCommonStateValues = (
  comparisonBaseValues: fabric.Textbox,
  textStyle: TextStyleType,
  uniformValues: Record<EDITABLE_TEXT_PROPERTIES, boolean>
) => {
  const tempState: Record<EDITABLE_TEXT_PROPERTIES, unknown> = { ...textStyle };
  Object.keys(uniformValues).forEach((key) => {
    const stateKey = key as EDITABLE_TEXT_PROPERTIES;
    if (uniformValues[stateKey]) {
      tempState[stateKey] = comparisonBaseValues[stateKey];
    } else {
      tempState[stateKey] = null;
    }
  });
  return tempState;
};
